import React from 'react';

export const SidebarMenuCaption = ({ label }) => (
    <li className="nxl-item nxl-caption">
        <label>{label}</label>
    </li>
);
